(function(){
  if(window.__AN_MOBILE_CARD_CART_STATE__) return;
  window.__AN_MOBILE_CARD_CART_STATE__ = true;

  var nativeFetch = window.fetch;
  var latestCart = null;
  var bagIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';

  function updateCards(cart){
    if(cart && cart.items) latestCart = cart;
    cart = latestCart || cart;
    if(!cart) return;

    var quantities = {};
    (cart.items || []).forEach(function(item){
      var id = String(item.variant_id || item.id || '');
      if(id) quantities[id] = (quantities[id] || 0) + (Number(item.quantity) || 0);
    });

    document.querySelectorAll('.an-mobile-card-cart').forEach(function(form){
      var input = form.querySelector('input[name="id"]');
      var button = form.querySelector('.an-mobile-card-cart__button:not(.is-sold-out)');
      if(!input || !button) return;

      var quantity = quantities[String(input.value)] || 0;
      form.setAttribute('data-an-cart-quantity', String(quantity));
      form.classList.toggle('is-in-cart', quantity > 0);

      if(quantity > 0){
        button.innerHTML = '<span class="an-mobile-card-cart__added-label">Added</span><span class="an-mobile-card-cart__count">+' + quantity + '</span>';
        button.setAttribute('aria-label', quantity + ' in cart. Add another ' + (form.getAttribute('data-name') || 'item'));
      } else {
        button.innerHTML = '<span>Add to Cart</span>' + bagIcon;
        button.setAttribute('aria-label', 'Add ' + (form.getAttribute('data-name') || 'item') + ' to cart');
      }
    });
  }

  function isCartResponse(url){
    url = String(url || '').split('?')[0];
    return /\/cart(?:\/change)?\.js$/.test(url);
  }

  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url);
    return nativeFetch.apply(this, arguments).then(function(response){
      if(response && response.ok && isCartResponse(url)){
        response.clone().json().then(function(cart){
          setTimeout(function(){ updateCards(cart); }, 0);
        }).catch(function(){});
      }
      return response;
    });
  };

  function readInitialCart(){
    var route = (window.AN_ROUTES && window.AN_ROUTES.cart) || '/cart';
    nativeFetch(route + '.js', { headers:{ 'Accept':'application/json' } })
      .then(function(response){ return response.ok ? response.json() : null; })
      .then(function(cart){ if(cart) updateCards(cart); })
      .catch(function(){});
  }

  function observeNewCards(){
    if(!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function(records){
      var found = false;
      records.forEach(function(record){
        Array.prototype.forEach.call(record.addedNodes || [], function(node){
          if(found || !node || node.nodeType !== 1) return;
          if((node.matches && node.matches('.an-mobile-card-cart')) || (node.querySelector && node.querySelector('.an-mobile-card-cart'))) found = true;
        });
      });
      if(found && latestCart) updateCards(latestCart);
    });
    observer.observe(document.documentElement, { childList:true, subtree:true });
  }

  window.anUpdateMobileCardCartState = updateCards;
  observeNewCards();
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', readInitialCart); else readInitialCart();
})();
